"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGptImage = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const user_1 = require("../store/selectors/user");
const user_2 = require("../slices/user");
const useCharacter_1 = require("../hooks/useCharacter");
const useRequest_1 = __importDefault(require("./useRequest"));
const messeges_1 = require("../services/messeges");
const useGptImage = () => {
    const { request } = (0, useRequest_1.default)();
    const character = (0, react_redux_1.useSelector)(user_1.selectCharacterProfile);
    const conversationId = (0, react_redux_1.useSelector)((state) => state.getUserOptions.conversation?.id);
    const imageGeneratedId = (0, react_redux_1.useSelector)((state) => state.getUserOptions.generatedImageId);
    const { refreshStoreMessages } = (0, useCharacter_1.useCharacter)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const generateImages = (0, react_1.useCallback)(async (selectedText, messageId, character, regenerate) => {
        console.log("selectedText", character);
        const { imageModelId, styleString, aspectRatio } = character;
        await dispatch((0, user_2.setImageLoading)(true));
        await dispatch((0, user_2.setChatAction)(regenerate ? "regenerate" : "generate"));
        if (regenerate && imageGeneratedId !== messageId) {
            dispatch((0, user_2.setGeneratedImageId)(messageId));
        }
        const imageApiDto = {
            conversationId: conversationId,
            stream: false,
            message: `${selectedText}`,
            negativePrompt: "", //duplicate body, deformed, deformed face, deformed nose, duplicate limbs, two heads, two mouths, not real, duplicate nose, duplicate teeth, six fingers, words, logos, letters
            // style: "Dreamlike", //for regeneration
            modelId: imageModelId ?? 'black-forest-labs/flux-schnell',
            ...aspectRatio && { aspectRatio },
            ...styleString && { styleString },
            ...(messageId && regenerate
                ? { messageId }
                : { parentMessageId: messageId }),
        };
        try {
            await request(messeges_1.sendMessegeImages, imageApiDto)
                .then(async (response) => {
                if (response) {
                    const imageMessage = response.data;
                    if (conversationId == response.data.conversationId) {
                        if (regenerate) {
                            dispatch((0, user_2.updateMessage)(imageMessage));
                        }
                        else {
                            dispatch((0, user_2.patchMessage)({
                                id: messageId,
                                mediaId: imageMessage.id.toString(),
                            }));
                            dispatch((0, user_2.addStoredMessage)(imageMessage));
                        }
                    }
                }
            })
                .catch((e) => {
                console.log("hmmm:", e);
            });
        }
        catch (e) {
            console.log("Image generation error:", e);
        }
        await dispatch((0, user_2.setImageLoading)(false));
    }, [conversationId, imageGeneratedId, request]);
    return {
        generateImages,
    };
};
exports.useGptImage = useGptImage;
